import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { Body, Button, ButtonGroup, Grid, GridColumn, Modal, Spinner, TextArea } from "@livingdesign/react";
import moment from "moment";
import { useState, useEffect } from "react";

import Label from "../../TextField/Label/Label";
import { CANCEL } from "../../../constants/actionButtons";
import { EXTERNAL_USERS_DEACTIVATE_MSG, EXTERNAL_USERS_DEACTIVATE_TITLE, EXTERNAL_USERS_REACTIVATE_MSG_WITH_METADATA, EXTERNAL_USERS_REACTIVATE_TITLE, ACTIVATE } from "../../../constants/constants";
import { BACKEND_DATE_FORMAT } from "../../../constants/dateFormats";

const Actions = ({ handleOpenClose, loading, action, handleActivateDeactivateUserAction, metadata }) => {
  return (
    <ButtonGroup>
      <Button
        data-testid="goback-btn"
        size="small"
        onClick={() => handleOpenClose(false)}
        disabled={loading}
      >
        {CANCEL}
      </Button>
      <Button
        variant={action === ACTIVATE ? "primary" : "destructive"}
        size="small"
        data-testid="continue-btn"
        onClick={() => handleActivateDeactivateUserAction(metadata)}
        disabled={loading || (action === ACTIVATE && (!metadata.recentActivatedOn || !metadata.recentActivatedOnComment))}
      >
        {loading ? (<Spinner color="white" size="small" />) : action}
      </Button>
    </ButtonGroup>
  );
};

/**
* Activate/Deactivate User modal
*/
const ActivateDeactivateUserModal = ({ open, handleOpenClose, loading, action, handleActivateDeactivateUserAction }) => {
  const title = action === ACTIVATE ? EXTERNAL_USERS_REACTIVATE_TITLE : EXTERNAL_USERS_DEACTIVATE_TITLE;
  const message = action === ACTIVATE ? EXTERNAL_USERS_REACTIVATE_MSG_WITH_METADATA : EXTERNAL_USERS_DEACTIVATE_MSG;
  const [recentActivatedOn, setRecentActivatedOn] = useState();
  const [recentActivatedOnComment, setRecentActivatedOnComment] = useState("");

  useEffect(()=>{
    setRecentActivatedOn()
    setRecentActivatedOnComment("")
  },[open])
  
  return (
    <Modal
      onClose={(event, reason) => {
        handleOpenClose(false);
      }}
      isOpen={open}
      actions={
        <Actions
          loading={loading}
          open={open}
          handleOpenClose={handleOpenClose}
          action={action}
          handleActivateDeactivateUserAction={handleActivateDeactivateUserAction}
          metadata={{  recentActivatedOn,  recentActivatedOnComment }}
        />
      }
      size="medium"
      title={title}
    >{
        action === ACTIVATE ? (
          <Grid >
            <div onClick={(e)=>e.stopPropagation()}>
            <GridColumn sm={12}>
              <Body as="p" size="large">
                <p>{message}</p>
              </Body>
            </GridColumn>
            <GridColumn sm={12} UNSAFE_style={{paddingBottom: 15}}>
              <Label text={"Reactivation effective as of"} mandatoryField />
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker
                  disablePortal={true}
                  sx={{ width: "100%" }}
                  minDate={moment().subtract(3, "months")} 
                  maxDate={moment(new Date())}
                  value={recentActivatedOn ? moment(recentActivatedOn) : null} 
                  onChange={(date) => {
                    setRecentActivatedOn(date ? moment(date).format(BACKEND_DATE_FORMAT) : null);
                  }}
                  slotProps={{
                    popper: { disablePortal:true},
                    inputAdornment: { position: "end" },
                    textField: {
                      InputProps: { style: { color: "#2E2F32" } },
                      name: "effectiveDate",
                      "data-testid": "edittimekeeperprofile-effectiveDate",
                      id: "edittimekeeperprofile-effectiveDate",
                    },
                  }}
                />
              </LocalizationProvider>
            </GridColumn>
            <GridColumn sm={12}>
              <Label text={"Reactivation comments"} mandatoryField />
              <TextArea
                onChange={(e) => setRecentActivatedOnComment(e.target.value)}
                value={recentActivatedOnComment}
                textAreaProps={{
                  name: "reactivation-comments",
                }}
                maxLength={250}
                data-testid="reactivation-comments"
                id="reactivation-comments"
              />
            </GridColumn>
            </div>
          </Grid>
        ) : (
          <Grid>
            <Body as="p" size="large">
              <p>{message}</p>
            </Body>
          </Grid>
        )
      }

    </Modal>
  );
};

export default ActivateDeactivateUserModal;